import React from 'react'
import '../Styles/anuncio.css'

const anuncio1 = ({title1, text1}) => {
    return ( 
        <div className= "anuncios">
            <h2>{title1}</h2>
            <p>{text1}</p> <br/>
        </div>
     );
}
 
export default anuncio1;